/* eslint-disable */
import $ from 'jquery';
import renderMap from './map';

$('.js-tabnav').on('click', function() {
    $('.js-tabnav').removeClass('is-active');

    const $this = $(this);
    $this.addClass('is-active');

    dataLayer.push({
        event: `switchTab${$this.data('name')}`,
    });

    $('.js-tab')
        .hide()
        .eq($(this).index())
        .show();

    renderMap();
});
